<template>
  <div style="height: calc(100% - 90px)">
    <div id="formTable">
      <div class="formTableItem" @click="getRili">
        <p class="label">负责人</p>
        <div class="content">{{ manager }}</div>
      </div>
      <div class="formTableItem">
        <p class="label">电话</p>
        <div class="content">{{ tel }}</div>
      </div>
      <div class="formTableItem">
        <p class="label">月休天数</p>
        <div class="content">{{ vacationDay }}</div>
      </div>
    </div>

    <table id="paibantable">
      <thead>
        <tr>
          <td style="width: 150px">日期</td>
          <td>
            <span style="width: 220px; display: inline-block">班次</span>
            <span style="width: 100px; display: inline-block">人数</span>
            <span style="width: 50px; display: inline-block">排班人员</span>
          </td>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(item, index) in classesList" :key="index">
          <td style="width: 150px">{{ utils.time(item.cdate, "mmdd") }}</td>
          <td>
            <div
              class="awwewewel"
              v-for="(x, index1) in item.classes"
              :key="index1"
            >
              <h3>
                {{ x.name }}:
                <span style="margin-left: 10px">
                  <span
                    v-for="(y, index2) in x.timeList"
                    :key="index2"
                    style="width: 90px; display: inline-block"
                    >{{ y.startTime }}-{{ y.endTime }}</span
                  >
                </span>
                <span style="width: 100px; display: inline-block">
                  {{ x.manNum }}人</span
                >
                <!-- <Checkbox :value="checkAll">全选</Checkbox> -->
              </h3>
              <div>
                <CheckboxGroup v-model="x.userIds">
                  <Checkbox
                    :label="item.userId"
                    v-for="(item, index3) in persons"
                    :key="index3"
                    >{{ item.name }}</Checkbox
                  >
                </CheckboxGroup>
              </div>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
<script>
export default {
  data() {
    return {
      persons: [],
      classesList: [],
      manager: "",
      vacationDay: "",
      tel: "",
      start: 0,
      end: 0,
    };
  },
  methods: {
    reData(v) {
      console.log(v);
      this.reset();
      setTimeout(() => {
        this.persons = v.persons;
        this.classesList = v.classesList;
        this.start = v.start;
        this.end = v.end;
        this.manager = v.classesList[0].manager;
        this.tel = v.classesList[0].tel;
        this.vacationDay = v.classesList[0].vacationDay;
        if (v.fresh) {
          this.getRili();
        }
      }, 200);
    },
    getRili() {
      var t = this.start;
      var s = new Date(this.start);
      var e = new Date(this.end);
      var m = this.classesList[0];
      var objArray = new Array();
      for (let i = 0; i <= e.getDate() - s.getDate(); i++) {
        m.cdate = objArray.length == 0 ? t : (t += 86400000);
        objArray.push(JSON.parse(JSON.stringify(m)));
      }
      this.classesList = objArray;
    },
    readData() {
      return this.classesList;
    },
    reset() {
      this.persons = [];
      this.classesList = [];
      this.manager = "";
      this.vacationDay = "";
    },
  },
};
</script>
<style lang="">
.awwewewel {
  display: flex;
  margin-top: 10px;
}
.awwewewel h3 {
  font-size: 14px;
}
#paibantable {
  margin-top: 0px;
  height: calc(100% - 60px);
  margin-bottom: 20px;
  border: solid #ccc;
  border-width: 4px 0;
}
#paibantable tr {
  width: 100%;
}
#paibantable th {
  line-height: 3;
}

#paibantable td {
  line-height: 2;
}
#paibantable thead {
  font-size: 14px;
}
#paibantable thead,
#paibantable tbody tr {
  display: table;
  width: 100%;
  table-layout: fixed;
}
#paibantable thead {
  width: calc(100% - 1em);
}
#paibantable tbody {
  display: block;
  height: calc(100% - 32px);
  overflow-y: auto;
  border-top: solid 1px #ccc;
  padding-top: 10px;
}
#paibantable tbody tr:nth-child(2n) {
  background: #e6f2f8;
}
</style>


// WEBPACK FOOTER //
// src/components/person/renyuanList.vue